import { z } from 'zod';
import { email, phone } from './common.js';
import { ContactType } from '../types/enums.js';
export const createContactSchema = z.object({
    name: z.string().min(1).max(120),
    phone,
    email: z.union([email, z.literal('')]).nullable().optional(),
    contactType: z.nativeEnum(ContactType),
    customerId: z.string().uuid().nullable().optional(),
    customer: z.string().nullable().optional(),
    role: z.string().nullable().optional(),
    dept: z.string().nullable().optional(),
    linkedin: z.string().url().or(z.literal('')).nullable().optional(),
    address: z.string().nullable().optional(),
    postcode: z.string().nullable().optional(),
    photo: z.string().nullable().optional(),
    notes: z.string().nullable().optional(),
    projects: z.array(z.string()).default([]),
});
export const updateContactSchema = createContactSchema.partial();
export const contactQuerySchema = z.object({
    search: z.string().optional(),
    contactType: z.nativeEnum(ContactType).optional(),
    customerId: z.string().uuid().optional(),
    customer: z.string().optional(),
});
//# sourceMappingURL=contact.js.map